import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { ENV_DEFAULTS } from '../config/env'

interface EnvState {
  apiBaseUrl: string
  setApiBaseUrl: (url: string) => void
}

export const useEnvStore = create<EnvState>()(
  persist(
    (set) => ({
      apiBaseUrl: ENV_DEFAULTS.apiBaseUrl,
      setApiBaseUrl: (url) => set({ apiBaseUrl: url }),
    }),
    {
      name: 'fursahub-admin-env',
      // Reset any old absolute URLs — all envs now route through Vite proxy paths
      merge: (persisted, current) => {
        const stored = (persisted as Partial<EnvState>).apiBaseUrl
        if (stored && stored.startsWith('http')) {
          return { ...current, apiBaseUrl: ENV_DEFAULTS.apiBaseUrl }
        }
        return { ...current, ...(persisted as Partial<EnvState>) }
      },
    },
  ),
)
